import React, { Component } from 'react'
import arrowRight from '../img/right-arrow.svg'
import arrowLeft from '../img/left-arrow.svg'
import Pug from "../img/dog.svg"
import {FaReact, FaGulp, FaBootstrap} from "react-icons/fa"
import {DiPhotoshop, DiHtml5, DiCss3, DiSass, DiLess, DiStylus, DiJavascript1, DiJqueryLogo } from "react-icons/di"

export default class Skills extends Component {
    render() {
        return (
            <div className="skills">
                <div className="title">
                    <div className="title__img">
                        <img src={arrowLeft} height="25px" alt="arrow right"/>
                    </div>
                    <div className="title__heading">
                        <h1>My skills</h1>
                    </div>
                    <div className="title__img">
                        <img src={arrowRight} height="25px" alt="arrow right"/>
                    </div>
                </div>
                
                <div className="skills-content">
                    <div className="skills-content__item">
                        <div className="skills-content__icon">
                            <DiPhotoshop className="skills__icon"/>
                        </div>
                        <span className="skills-content__name">Photoshop</span>
                        <div className="skills-content__progress">
                            <div style={{width: '54%'}} className="skills-content__progressAc progressAc">
                                <div  className="skills-content__percent">54%</div>
                            </div>
                        </div>
                    </div>
                    <div className="skills-content__item">
                        <div className="skills-content__icon">
                            <DiHtml5 className="skills__icon"/>
                        </div>
                        <span className="skills-content__name">HTML5</span>
                        <div className="skills-content__progress">
                            <div style={{width: '87%'}}  className="skills-content__progressAc progressAc">
                                <div  className="skills-content__percent ">87%</div>
                            </div>
                        </div>
                    </div>
                    <div className="skills-content__item">
                        <div className="skills-content__icon">
                            <DiCss3 className="skills__icon"/>
                        </div>
                        <span className="skills-content__name">CSS3</span>
                        <div className="skills-content__progress">
                            <div style={{width: '91%'}} className="skills-content__progressAc progressAc">
                                <div   className="skills-content__percent">91%</div>
                            </div>
                        </div>
                    </div>

                    <div className="skills-content__item">
                        <div className="skills-content__icon">
                            <DiSass className="skills__icon"/>
                        </div>
                        <span className="skills-content__name">SASS</span>
                        <div className="skills-content__progress">
                            <div style={{width: '88%'}} className="skills-content__progressAc progressAc">
                                <div  className="skills-content__percent">88%</div>
                            </div>
                        </div>
                    </div>
                    <div className="skills-content__item">
                        <div className="skills-content__icon">
                            <DiLess className="skills__icon"/>
                        </div>
                        <span className="skills-content__name">LESS</span>
                        <div className="skills-content__progress">
                            <div style={{width: '86%'}}  className="skills-content__progressAc progressAc">
                                <div  className="skills-content__percent ">86%</div>
                            </div>
                        </div>
                    </div>
                    <div className="skills-content__item">
                        <div className="skills-content__icon">
                            <DiStylus className="skills__icon"/>
                        </div>
                        <span className="skills-content__name">Stylus</span>
                        <div className="skills-content__progress">
                            <div style={{width: '86%'}} className="skills-content__progressAc progressAc">
                                <div   className="skills-content__percent">86%</div>
                            </div>
                        </div>
                    </div>

                    <div className="skills-content__item">
                        <div className="skills-content__icon">
                            <DiJavascript1 className="skills__icon"/>
                        </div>
                        <span className="skills-content__name">JavaScript, ES6</span>
                        <div className="skills-content__progress">
                            <div style={{width: '46%'}} className="skills-content__progressAc progressAc">
                                <div  className="skills-content__percent">46%</div>
                            </div>
                        </div>
                    </div>
                    <div className="skills-content__item">
                        <div className="skills-content__icon">
                            <DiJqueryLogo className="skills__icon"/>
                        </div>
                        <span className="skills-content__name">Jquery</span>
                        <div className="skills-content__progress">
                            <div style={{width: '43%'}}  className="skills-content__progressAc progressAc">
                                <div  className="skills-content__percent ">43%</div>
                            </div>
                        </div>
                    </div>
                    <div className="skills-content__item">
                        <div className="skills-content__icon">
                            <img src={Pug} style={{height: '45px'}} alt=""/>
                        </div>
                        <span className="skills-content__name">Pug</span>
                        <div className="skills-content__progress">
                            <div style={{width: '85%'}} className="skills-content__progressAc progressAc">
                                <div   className="skills-content__percent">85%</div>
                            </div>
                        </div>
                    </div>

                    <div className="skills-content__item">
                        <div className="skills-content__icon">
                            <FaBootstrap className="skills__icon"/>
                        </div>
                        <span className="skills-content__name">Bootsrap4</span>
                        <div className="skills-content__progress">
                            <div style={{width: '81%'}} className="skills-content__progressAc progressAc">
                                <div  className="skills-content__percent">81%</div>
                            </div>
                        </div>
                    </div>
                    <div className="skills-content__item">
                        <div className="skills-content__icon">
                            <FaGulp className="skills__icon"/>
                        </div>
                        <span className="skills-content__name">Gulp4</span>
                        <div className="skills-content__progress">
                            <div style={{width: '86%'}}  className="skills-content__progressAc progressAc">
                                <div  className="skills-content__percent ">86%</div>
                            </div>
                        </div>
                    </div>
                    <div className="skills-content__item">
                        <div className="skills-content__icon">
                            <FaReact className="skills__icon"/>
                        </div>
                        <span className="skills-content__name">React</span>
                        <div className="skills-content__progress">
                            <div style={{width: '35%'}} className="skills-content__progressAc progressAc">
                                <div   className="skills-content__percent">35%</div>
                            </div>
                        </div>
                    </div>
                </div>
        </div>
        )
    }
}
